import React from "react";
import { Route } from "react-router-dom";
import LayoutCanvas from "../../Layouts/Canvas";

const Canvas = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => (
        <LayoutCanvas>
          <Component {...props} />
        </LayoutCanvas>
      )}
    />
  );
};

export default Canvas;
